const NEGATIVE_HRT_VALUES = new Set([
  "",
  "none",
  "none / not started yet",
  "not started yet",
  "not sure",
  "unsure",
  "no",
  "false",
]);

type HrtLikeUser = {
  hrtType?: string | null;
  hrtTypes?: string[] | null;
  hrtStartDate?: string | null;
  hrt_start_date?: string | null;
  onHrt?: boolean | null;
  onHRT?: boolean | null;
  isOnHrt?: boolean | null;
  is_on_hrt?: boolean | null;
};

function hasPositiveHrtType(value: unknown): value is string {
  if (typeof value !== "string") return false;
  return !NEGATIVE_HRT_VALUES.has(value.trim().toLowerCase());
}

export function getHrtName(user: HrtLikeUser | null | undefined): string {
  if (!user) return "";
  if (hasPositiveHrtType(user.hrtType)) return user.hrtType.trim();
  if (Array.isArray(user.hrtTypes)) {
    const names = user.hrtTypes.filter(hasPositiveHrtType).map((s) => s.trim());
    if (names.length) return names.join(", ");
  }
  return "";
}

export function getHrtStartDate(user: HrtLikeUser | null | undefined): string | null {
  if (!user) return null;
  return user.hrtStartDate || user.hrt_start_date || null;
}

export function isOnHrt(user: HrtLikeUser | null | undefined): boolean {
  if (!user) return false;
  return Boolean(
    user.onHrt === true ||
      user.onHRT === true ||
      user.isOnHrt === true ||
      user.is_on_hrt === true ||
      getHrtName(user) ||
      getHrtStartDate(user),
  );
}